import React from 'react'
import CloseIcon from '@/assets/ic_close.svg?react'

export interface IProps {
    className?: string
    size?: 'default' | 'small'
    onClick?: () => void
}

const CloseButton: React.FC<IProps> = ({ className, size = 'default', onClick }) => {
    const isSmall = size === 'small'

    return (
        <button
            className={`flex items-center justify-center rounded-[5px] border border-main_b ${isSmall ? 'p-[5px]' : 'p-[8px]'} ${className}`}
            onClick={onClick}>
            <CloseIcon className={isSmall ? 'h-[12px] w-[12px]' : undefined} />
        </button>
    )
}

export default CloseButton
